module.exports = __webpack_public_path__ + "img/编组 5@2x.f325b704.png";